/**
 * The English strings the /muhurat/<event>/ date finder's SSR'd shell
 * (MuhuratDateFinder.lazy.tsx) and its island (MuhuratDateFinder.tsx) share,
 * so every frame before and after the island mounts reads the same words
 * (MuhuratDateFinder.lazy.test.tsx). Island-only strings (the Tara chips and
 * callout, the day-check result) live with the island, out of the first load.
 */
export const FINDER_COPY = {
  heading: "Check these dates for your star and city",
  janmaLabel: "Your Janma Nakshatra (birth star)",
  janmaPlaceholder: "Choose your birth star",
  // The Janma Nakshatra is only certain with the birth time: never call it optional.
  janmaHelpLead: "Not sure? Find it with the",
  janmaHelpLink: "Nakshatra Calculator",
  janmaHelpTail: "— it needs the birth date, time and place.",
  taraLink: "What is Tara Balam?",
  cityLabel: "City for the day check",
} as const;

export function cityHelp(city: string): string {
  return `"Check in ${city}" on a date shows ${city}'s sunrise, sunset and Rahu Kaal for that date.`;
}

export function checkLabel(city: string, open: boolean): string {
  return open ? `Hide the ${city} check` : `Check in ${city}`;
}

export function panelHeading(city: string, date: string): string {
  return `${city} on ${date}`;
}

export function checkingLine(city: string): string {
  return `Checking sunrise, sunset and Rahu Kaal in ${city}…`;
}
